import cn from 'clsx'

import { Button } from 'shared-components'
import { returnDate } from 'shared-functions'

import s from './Intro.module.sass'

function Intro({ post }: any) {
    const { _createdAt, title, category } = post

    return (
        <section className={s.Intro}>
            <div className={cn(s.Cont, 'container')}>
                {_createdAt && (
                    <span
                        className={cn(s.Date, 'smallCaps')}
                        dangerouslySetInnerHTML={{ __html: returnDate(_createdAt) }}
                    />
                )}
                {title && <h2 dangerouslySetInnerHTML={{ __html: title }} />}
                {category && (
                    <div className={s.Category}>
                        <Button title={category?.name} small noArrow />
                    </div>
                )}
            </div>
        </section>
    )
}

export default Intro
